import { Grid } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import BoolFilterDropdown from '@Common/Components/BoolFilterDropdown'
import TextField from '@Common/Components/TextField'
import FiltersForm from '@Common/Forms/FiltersForm'
import { setStateFromEvent } from '@Common/Utils/Events'

const UsersFilterForm = ({ onClose, fields, setField, onReset, onSave }) => {
  const { t } = useTranslation()
  return (
    <FiltersForm title={t('auth:ui.FilterUsers')} onClose={onClose} onReset={onReset} onSave={onSave}>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <TextField
            label={t('auth:fields.eMail')}
            value={fields.eMail}
            onChange={setStateFromEvent(setField('eMail'))}
            fullWidth
          />
        </Grid>
        <Grid item md={6}>
          <BoolFilterDropdown
            label={t('auth:fields.active')}
            value={fields.active}
            onChange={setStateFromEvent(setField('active'))}
            fullWidth
          />
        </Grid>
      </Grid>
    </FiltersForm>
  )
}

UsersFilterForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  setField: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default UsersFilterForm
